import "./BuyStream.scss";

const BuyStream = () => {
  return (
    <a
      href="https://soundcloud.com/kanyewest/sets/vultures-1-2"
      target="_blank"
      rel="noreferrer"
      className="buy-stream__wrapper"
    >
      STREAM
    </a>
  );
};

export default BuyStream;